import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { PendingClientProptype } from './prop-types';
import { FormattedMessage } from 'react-intl';
import ModalPortal from '../../../components/modal-portal';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';
import { cancelPendingClient as cancelPendingClientAsync } from '../api/fulfillment-delegation';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { NotificationService, NOTIFICATION_TYPE_ERROR, NOTIFICATION_DURATIONS } from 'ui-components/services/notification-service';

import messages from './messages';
import style from './style.module.less';

const errorNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.cancelPendingClientError} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

const CancelPendingClientModal = ({ client, onClose, reloadGrid }) => {
  const [isLoading, setIsLoading] = useAsyncSafeState(false);
  const { clientName, externalInviteId } = client;

  const cancelPendingClient = useCallback(async () => {
    setIsLoading(true);
    try {
      await cancelPendingClientAsync(externalInviteId);
      onClose();
      reloadGrid();
    } catch {
      NotificationService.showNotification(errorNotification);
      setIsLoading(false);
    }
  }, [externalInviteId, onClose, reloadGrid, setIsLoading]);

  return (
    <ModalPortal onClose={onClose}>
      <Modal size='small'>
        <ModalHeader>
          <FormattedMessage {...messages.cancelPendingClientModalHeader} />
        </ModalHeader>
        <ModalBody>
          <div className={style['cancel-pending-client-modal-body']}>
            <FormattedMessage {...messages.cancelPendingClientModalBody} values={{ clientName }} />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button disabled={isLoading} onClick={cancelPendingClient} theme='danger'>
            <FormattedMessage {...messages.cancelPendingClientButton} />
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

CancelPendingClientModal.propTypes = {
  client: PendingClientProptype.isRequired,
  onClose: PropTypes.func.isRequired,
  reloadGrid: PropTypes.func.isRequired,
};

export default CancelPendingClientModal;
